import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AVAILABLE_ROLES = [
  { value: 'ROLE_ADMIN', label: 'Administrateur' },
  { value: 'ROLE_HOTESS', label: 'Hôtesse' },
  { value: 'ROLE_SELLER', label: 'Caissier' }
];

function Form({ open, onClose, initialData = null, onSubmit }) {
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    roles: [],
    pin: '',
    password: ''
  });

  React.useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        email: initialData.email || '',
        roles: initialData.roles || [],
        pin: initialData.pin || '',
        password: initialData.password || ''
      });
    } else {
      setFormData({
        name: '',
        email: '',
        roles: [],
        pin: '',
        password: ''
      });
    }
  }, [initialData]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      ...formData,
      id: initialData?.id
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e0e0e0'
      }}>
        <span>{initialData ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}</span>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 3 }}>
          <TextField
            fullWidth
            label="Nom"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            size="small"
          />

          <TextField
            fullWidth
            label="Email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            size="small"
          />

          <TextField
            fullWidth
            label="Mot de passe"
            type="password"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            required={!initialData}
            size="small"
          />

          <FormControl fullWidth size="small">
            <InputLabel>Rôles</InputLabel>
            <Select
              multiple
              value={formData.roles}
              onChange={(e) => setFormData({ ...formData, roles: e.target.value })}
              required
            >
              {AVAILABLE_ROLES.map((role) => (
                <MenuItem key={role.value} value={role.value}>
                  {role.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="PIN (optionnel)"
            type="number"
            value={formData.pin}
            onChange={(e) => setFormData({ ...formData, pin: e.target.value })}
            size="small"
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={onClose}>
            Annuler
          </Button>
          <Button type="submit" variant="contained">
            {initialData ? 'Modifier' : 'Ajouter'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

Form.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialData: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
    pin: PropTypes.string,
    password: PropTypes.string
  })
};

export default Form; 